import { createSelector } from '@reduxjs/toolkit';
import { getOrdersState } from './getOrdersState';

export const getOrdersFilters = createSelector(getOrdersState, (state) => state?.filters);
